import { supabase } from '../lib/supabase';

// API URL 설정
const determineApiUrl = () => {
  const nodeEnv = process.env.NODE_ENV;
  const hostname = window.location.hostname;
  
  console.log('🌐 환경 정보:', {
    NODE_ENV: nodeEnv,
    hostname: hostname,
    location: window.location.href,
    SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL
  });
  
  if (!process.env.REACT_APP_SUPABASE_URL) {
    console.error('❌ Supabase URL이 설정되지 않았습니다. .env 파일을 확인해주세요.');
    return '';
  }
  
  const apiUrl = process.env.REACT_APP_SUPABASE_URL;
  console.log('🔌 Supabase API URL 설정:', apiUrl);
  return apiUrl;
};

export const API_URL = determineApiUrl();

// API 요청 헤더 생성
export const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json'
  };

  // Supabase anon key 추가
  if (process.env.REACT_APP_SUPABASE_ANON_KEY) {
    headers['apikey'] = process.env.REACT_APP_SUPABASE_ANON_KEY;
  } else {
    console.error('❌ Supabase Anon Key가 설정되지 않았습니다. .env 파일을 확인해주세요.');
  }

  // Supabase 토큰 가져오기
  try {
    // localStorage에서 토큰 조회
    const authData = localStorage.getItem('supabase.auth.token');
    console.log('🔍 localStorage 토큰 데이터:', authData ? '존재' : '없음');
    
    if (authData) {
      const session = JSON.parse(authData);
      if (session?.currentSession?.access_token) {
        headers.Authorization = `Bearer ${session.currentSession.access_token}`;
        console.log('🔐 localStorage에서 Supabase 토큰 찾음');
        return headers;
      }
    }
    
    // supabase-js의 세션에서 토큰 조회 시도
    const supabaseSession = JSON.parse(localStorage.getItem('sb-dcckozivryrjlphvkrxc-auth-token'));
    if (supabaseSession?.access_token) {
      headers.Authorization = `Bearer ${supabaseSession.access_token}`;
      console.log('🔐 supabase-js 세션에서 토큰 찾음');
    } else {
      console.log('⚠️ 유효한 인증 토큰을 찾을 수 없습니다');
    }
  } catch (error) {
    console.error('❌ 토큰 조회 중 오류 발생:', error);
  }

  return headers;
};

// 에러 처리 함수
export const handleApiError = async (response) => {
  console.log('🔍 API 응답 상태:', response?.status, response?.statusText);
  console.log('📦 응답 타입:', response?.constructor?.name);

  if (!response.ok) {
    let errorData = '';
    
    // Response 객체인 경우에만 json() 시도
    if (response instanceof Response) {
      try {
        errorData = await response.json();
      } catch (e) {
        try {
          errorData = await response.text();
        } catch (textError) {
          errorData = '응답 데이터를 읽을 수 없습니다.';
        }
      }
    } else {
      errorData = response?.message || '알 수 없는 오류가 발생했습니다.';
    }

    console.error('❌ API 오류:', errorData);
    throw new Error(typeof errorData === 'string' ? errorData : JSON.stringify(errorData));
  }

  return response;
}; 